/** Admin federation — identity-provider connection toggles + activity audit. */
import { apiGet, apiPost } from '../client.js';
import type { FederationAuditEvent, FederationConnection } from '../types.js';

export interface ListAuditEventsFilters {
  idp_name?: string;
  event_type?: string;
  limit?: number;
  offset?: number;
}

export function listConnections(): Promise<FederationConnection[]> {
  return apiGet<FederationConnection[]>('/api/v1/admin/federation/connections');
}

export function enableConnection(id: string): Promise<FederationConnection> {
  return apiPost<FederationConnection>(`/api/v1/admin/federation/connections/${id}/enable`, {});
}

export function disableConnection(id: string): Promise<FederationConnection> {
  return apiPost<FederationConnection>(`/api/v1/admin/federation/connections/${id}/disable`, {});
}

/** Newest first. `idp_name` narrows to one partner's activity. */
export function listAuditEvents(
  filters: ListAuditEventsFilters = {},
): Promise<FederationAuditEvent[]> {
  const params: Record<string, string> = {};
  if (filters.idp_name) params.idp_name = filters.idp_name;
  if (filters.event_type) params.event_type = filters.event_type;
  if (filters.limit !== undefined) params.limit = String(filters.limit);
  if (filters.offset !== undefined) params.offset = String(filters.offset);
  return apiGet<FederationAuditEvent[]>('/api/v1/admin/federation/audit', params);
}
